import { RecordManagement } from "app/class/record-management";

export interface GatePublicTranslation {
    text_key?: string;
    text_value?: string;
    language?: string;
}

const GATE_TRANSLATIONS_PAGE_SIZE = 5000;

export const fetchGatePublicTranslations = async (languages: string[], isPublic?: boolean): Promise<GatePublicTranslation[]> => {
    const records: GatePublicTranslation[] = [];
    let page = 1;
    let total = 0;

    do {
        const manager = new RecordManagement<GatePublicTranslation>("sys_translations")
            .where("language", "in", languages)
            // Stable order: without it PostgreSQL may repeat or skip rows across pages.
            .orderBy("id", "asc")
            .paginate(page, GATE_TRANSLATIONS_PAGE_SIZE);

        if (isPublic) {
            manager.where("public", true);
        }

        const response = await manager.run();
        const batch = response.data || [];
        records.push(...batch);
        total = response.meta?.total ?? records.length;
        if (!batch.length) break;
        page += 1;
    } while (records.length < total);

    return records;
};
